import { createStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(() =>
  createStyles({
    addMessageButton: {
      marginRight: '20px',
      marginLeft: '30px',
      width: 'auto',
    },
  }),
);
